import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { useState as m } from "react";
import { Menu as i } from "../Menu/Menu.js";
import { AppBar as c } from "../AppBar/AppBar.js";
import '../../assets/Page.css';function h({ children: a, Right: s, items: r, version: p = "" }) {
  const [t, e] = m(!1);
  return /* @__PURE__ */ n("div", { className: "page", children: [
    /* @__PURE__ */ o(
      i,
      {
        expanded: t,
        onClose: () => {
          e(!1);
        },
        items: r,
        version: p
      }
    ),
    /* @__PURE__ */ n("main", { className: "page-main", children: [
      /* @__PURE__ */ o(c, { onExpand: () => {
        e(!0);
      }, Right: s }),
      a
    ] })
  ] });
}
export {
  h as Page
};
//# sourceMappingURL=Page.js.map
